import React from 'react';
import ReactDOM from 'react-dom';
import regeneratorRuntime from "regenerator-runtime";

import App from './app.js';

import "./semantic/dist/semantic.css";

ReactDOM.render(<App />, document.getElementById('root'));